/**
 * Multiplayer wire protocol — single source of truth for both client
 * (transports) and server (RaceRoom DO).
 *
 * Versioning: every outbound `hello` carries `v`. The server rejects
 * mismatched majors so future breaking changes (delta sync, server-auth
 * collisions, replays) can't crash older clients.
 */
export const PROTOCOL_VERSION = 2;

/** Hard cap on simultaneous active players in one room. */
export const MAX_PLAYERS = 24;

/** Position ticks per second. 20 Hz → 50ms between snapshots. */
export const TICK_HZ = 20;
export const TICK_INTERVAL_MS = 1000 / TICK_HZ;

/** Heartbeat / keepalive. Pings every 1.5s; server prunes after 12s of
 *  silence. Generous margin so a single GC pause / lock-screen blip
 *  doesn't kick the player mid-race. */
export const HEARTBEAT_INTERVAL_MS = 1500;
export const HEARTBEAT_TIMEOUT_MS = 12000;

/** Position tick wire payload. */
export interface WireTick {
  /** Monotonic sequence number from the sender — client drops out-of-order. */
  seq: number;
  /** Arc length on the path. */
  s: number;
  /** Lateral offset within the path. */
  l: number;
  /** Compressed state. */
  st: "run" | "jump" | "hit" | "finished";
  /** Forward (along-path) velocity (m/s) — used for client extrapolation. */
  vs: number;
  /** Lateral velocity (m/s). */
  vl: number;
}
